import { inject } from 'vue'
import { zPaginationKey } from './constants'

export const usePagination = () => inject(zPaginationKey, {})
